import { render, staticRenderFns } from "./PaymentPlansList.vue?vue&type=template&id=5bc8898c&"
import script from "./PaymentPlansList.vue?vue&type=script&lang=js&"
export * from "./PaymentPlansList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports